"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(fb, services, route, dialogRef) {
        this.fb = fb;
        this.services = services;
        this.route = route;
        this.dialogRef = dialogRef;
        this.resetPasswordForm = this.fb.group({
            email: [null, forms_1.Validators.compose([forms_1.Validators.required, forms_1.Validators.email])]
        });
        this._sendingInProgress = false;
        this.afterRegClose = false;
    }
    ResetPasswordComponent.prototype.isEmailNotValid = function () {
        return this.resetPasswordForm.controls["email"].hasError("required") || this.resetPasswordForm.controls["email"].hasError("email");
    };
    Object.defineProperty(ResetPasswordComponent.prototype, "sendingInProgress", {
        get: function () {
            return this._sendingInProgress;
        },
        set: function (value) {
            this._sendingInProgress = value;
        },
        enumerable: true,
        configurable: true
    });
    ResetPasswordComponent.prototype.getEmailErrorMessage = function () {
        return this.resetPasswordForm.controls["email"].hasError("required") ? "Email is required" : this.resetPasswordForm.controls["email"].hasError("email") ? "Enter valid email address" : "";
    };
    ResetPasswordComponent.prototype.ngOnInit = function () { };
    ResetPasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.resetPasswordForm.invalid) {
            this.sendingInProgress = true;
            this.services.userService
                .resetPassword(this.resetPasswordForm.controls["email"].value, "")
                .then(function (r) {
                _this.sendingInProgress = false;
                _this.services.showInformation("We sent you an email with instructions how to reset your password");
                _this.services.route.navigate([r]);
                _this.afterRegClose = true;
                _this.dialogRef.close();
            })
                .catch(function (e) {
                _this.sendingInProgress = false;
                _this.services.showError(e);
            });
        }
    };
    return ResetPasswordComponent;
}());
exports.ResetPasswordComponent = ResetPasswordComponent;
